// tslint:disable-next-line
const VALID_EMAIL_PATERN = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const VALID_NUMBER_PATERN = /^\d+$/;

export const isEmpty = (str) => {
    return !str || str === 'undefined' || String(str).replace(/ /g, '').length === 0;
};

export const isEmptyObject = (obj = {}) => {
    return Object.keys(obj).length === 0;
};

export const isValidEmail = (email) => {
    return !VALID_EMAIL_PATERN.test(email);
};

export const isValidNumber = (number) => {
    return number !== '' && !VALID_NUMBER_PATERN.test(number);
};

export const isValidDecimalNumber = (number) => {
    const regexp = /^\d+(\.\d{1,})?$/;
    return number !== '' && regexp.test(number);
};

export const isValidPhone = (phone = '') => {
    if (phone.toString().length !== 10) {
        return true;
    }
};

export const isValidIdentification = (id) => {
    const identification = id.toString();
    if (identification.length !== 10) {
        return true;
    }
    const regionNumber = identification.substring(0, 2);
    if (!(regionNumber >= 1 && regionNumber <= 24)) {
        return true;
    }
    const sumDigits = identification.substring(0, 9).split('')
        .map((digit, index) => (index + 1) % 2 === 0 ? digit * 1 :digit * 2)
        .map(digit => digit > 9 ? digit - 9 : digit)
        .reduce((acc, digit) => acc + digit, 0);
    const modul10 = sumDigits % 10;
    const verifier = (modul10 === 0 ? 0 : (10 - modul10));
    return verifier !== parseInt(identification.charAt(9), 10);
};

export const objectHasProperty = (obj, property) => {
    if (typeof obj === 'undefined' || obj == null) {
        return false;
    }
    return Object.prototype.hasOwnProperty.call(obj, property);
};
